import { createSlice, PayloadAction, PrepareAction } from '@reduxjs/toolkit'

interface Market {
  id: string
  name: string
  flag_url?: string
}

interface MarketState {
  markets: Market[]
  selectedMarkets: Market[]
  loading: boolean
  error?: unknown
}

const initialState: MarketState = {
  markets: [],
  selectedMarkets: [],
  loading: false,
}

const marketSlice = createSlice({
  name: 'market',
  initialState,
  reducers: {
    loadingMarkets: (state) => {
      state.loading = true
    },
    loadingMarketsSuccess: (state, action: PayloadAction<Market[]>) => {
      state.markets = action.payload
      state.loading = false
    },
    loadingMarketsFail: (state, action: PayloadAction<unknown>) => {
      state.error = action.payload
      state.loading = false
    },
    setSelectedMarkets: (state, action: PayloadAction<Market[]>) => {
      state.selectedMarkets = action.payload
    },
    toggleMarket: {
      prepare(name: string, value: boolean) {
        return { payload: { name, value } }
      },
      reducer(state, action: PayloadAction<{ name: string; value: boolean }>) {
        const { name, value } = action.payload
        if (value && !state.selectedMarkets.some((item) => item.name === name)) {
          const addedMarket = state.markets.find((market) => market.name === name)
          if (addedMarket) {
            state.selectedMarkets.push(addedMarket)
          }
        } else {
          state.selectedMarkets = state.selectedMarkets.filter(
            (item) => item.name !== name
          )
        }
      },
    },
    clearMarkets: (state) => {
      state.selectedMarkets = []
    },
    reset: () => initialState,
  },
})

export const marketActions = marketSlice.actions
export const marketReducer = marketSlice.reducer
export default marketActions
